 <span [innerHTML]='displayName | highlight: searchTerm'></span>
<span [innerHTML]='jobTitle | highlight: searchTerm'></span>
<span [innerHTML]='phoneNumber | highlight: searchTerm'></span>
<span [innerHTML]='emailAddress | highlight: searchTerm'></span>
